import { IPrefetchConfig } from '@faire/web-api--source/indigofair/settings/IPrefetchConfig';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Controls full page prefetching on logged-in category as well as the threshold
 */
export const ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320 =
  'ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320' as SettingConst<
    'ENABLE_CATEGORY_LINK_TOGGLE_FULL_PAGE_PREFETCHING_250320',
    IPrefetchConfig,
    'RETAILER' | 'RETAILER_HEAD_TAGS' | 'VISITOR_WEB' | 'VISITOR_WEB_HEAD_TAGS'
  >;
